import {
  ClearStoreAction,
  LoadChecklistsAction,
  LoadChecklistsErrorAction,
  LoadChecklistsSuccessAction,
  LoadChecklistDetailAction,
  LoadChecklistDetailErrorAction,
  LoadChecklistDetailSuccessAction,
  LoadShiftHistoryPositionsAction,
  LoadShiftHistoryPositionsErrorAction,
  LoadShiftHistoryPositionsSuccessAction,
  LoadDataAction,
  LoadDataErrorAction,
  LoadDataSuccessAction,
  LoadShiftsAction,
  LoadShiftsErrorAction,
  LoadShiftsSuccessAction,
  LoadTenureTracksAction,
  LoadTenureTracksErrorAction,
  LoadTenureTracksSuccessAction,
} from './actions.d';
import actionTypes from './actionTypes';
import {
  ILoadChecklistsRequestPayload,
  ILoadChecklistsSuccessPayload,
  ILoadChecklistDetailRequestPayload,
  ILoadChecklistDetailSuccessPayload,
  ILoadShiftHistoryPositionsRequestPayload,
  ILoadShiftHistoryPositionsSuccessPayload,
  ILoadDataRequestPayload,
  ILoadDataSuccessPayload,
  ILoadLTenureTracksSuccessPayload,
  ILoadShiftsRequestPayload,
  ILoadShiftsSuccessPayload,
  ILoadTenureTracksRequestPayload,
} from '../types';

const actions = {
  loadData: (payload: ILoadDataRequestPayload): LoadDataAction => ({
    type: actionTypes.LOAD_DATA,
    payload,
  }),
  loadDataSuccess: (payload: ILoadDataSuccessPayload): LoadDataSuccessAction => ({
    type: actionTypes.LOAD_DATA_SUCCESS,
    payload,
  }),
  loadDataError: (): LoadDataErrorAction => ({
    type: actionTypes.LOAD_DATA_ERROR,
  }),
  loadShifts: <T1, T2>(payload: ILoadShiftsRequestPayload<T1, T2>): LoadShiftsAction<T1, T2> => ({
    type: actionTypes.LOAD_SHIFTS,
    payload,
  }),
  loadShiftsSuccess: (payload: ILoadShiftsSuccessPayload): LoadShiftsSuccessAction => ({
    type: actionTypes.LOAD_SHIFTS_SUCCESS,
    payload,
  }),
  loadShiftsError: (): LoadShiftsErrorAction => ({
    type: actionTypes.LOAD_SHIFTS_ERROR,
  }),
  loadTenureTracks: <T1, T2>(payload: ILoadTenureTracksRequestPayload<T1, T2>): LoadTenureTracksAction<T1, T2> => ({
    type: actionTypes.LOAD_TENURE_TRACKS,
    payload,
  }),
  loadTenureTracksSuccess: (payload: ILoadLTenureTracksSuccessPayload): LoadTenureTracksSuccessAction => ({
    type: actionTypes.LOAD_TENURE_TRACKS_SUCCESS,
    payload,
  }),
  loadTenureTracksError: (): LoadTenureTracksErrorAction => ({
    type: actionTypes.LOAD_TENURE_TRACKS_ERROR,
  }),
  loadShiftHistoryPositions: (payload: ILoadShiftHistoryPositionsRequestPayload): LoadShiftHistoryPositionsAction => ({
    type: actionTypes.LOAD_SHIFT_HISTORY_POSITIONS,
    payload,
  }),
  loadShiftHistoryPositionsSuccess: (
    payload: ILoadShiftHistoryPositionsSuccessPayload,
  ): LoadShiftHistoryPositionsSuccessAction => ({
    type: actionTypes.LOAD_SHIFT_HISTORY_POSITIONS_SUCCESS,
    payload,
  }),
  loadShiftHistoryPositionsError: (): LoadShiftHistoryPositionsErrorAction => ({
    type: actionTypes.LOAD_SHIFT_HISTORY_POSITIONS_ERROR,
  }),
  loadChecklists: <T1, T2>(payload: ILoadChecklistsRequestPayload<T1, T2>): LoadChecklistsAction<T1, T2> => ({
    type: actionTypes.LOAD_CHECKLISTS,
    payload,
  }),
  loadChecklistsSuccess: (payload: ILoadChecklistsSuccessPayload): LoadChecklistsSuccessAction => ({
    type: actionTypes.LOAD_CHECKLISTS_SUCCESS,
    payload,
  }),
  loadChecklistsError: (): LoadChecklistsErrorAction => ({
    type: actionTypes.LOAD_CHECKLISTS_ERROR,
  }),
  loadChecklistDetail: (payload: ILoadChecklistDetailRequestPayload): LoadChecklistDetailAction => ({
    type: actionTypes.LOAD_CHECKLIST_DETAIL,
    payload,
  }),
  loadChecklistDetailSuccess: (payload: ILoadChecklistDetailSuccessPayload): LoadChecklistDetailSuccessAction => ({
    type: actionTypes.LOAD_CHECKLIST_DETAIL_SUCCESS,
    payload,
  }),
  loadChecklistDetailError: (): LoadChecklistDetailErrorAction => ({
    type: actionTypes.LOAD_CHECKLIST_DETAIL_ERROR,
  }),
  clearStore: (): ClearStoreAction => ({
    type: actionTypes.CLEAR_STORE,
  }),
};

export default actions;
